import get from "lodash/get";
import getConfig from "../config";
import { StateGetterBase } from "./StateGetterBase";

const EMPTY_OBJECT = {}
export class UserStateGetter extends StateGetterBase {
    getUserMeta() {
        return get(getConfig(), "user", EMPTY_OBJECT)
    }
}